const upperCase = (str) => {
  const lower = str.toLowerCase();
  return lower.replace(/(^| )(\w)/g, function(x) {
    return x.toUpperCase();
  });
};

export default upperCase;



// WEBPACK FOOTER //
// ./src/scripts/upper-case.js